
import { LanguageObserver } from 'apprise-frontend-core/intl/langobserver'
import { ToggleConfig } from 'apprise-frontend-core/toggle/context'
import { FormExcludes } from 'apprise-frontend-core/utils/formexcludes'
import { TenantClientCache, TenantCloneProvider, TenantConfig, TenantConfigProvider, TenantExcludes, TenantExcludesProvider, TenantToggleProvider, TenantToggles } from 'apprise-frontend-iam/tenant/context'
import { PropsWithChildren } from 'react'
import { TenantInitialiser } from './initialiser'
import { TenantLoader } from './loader'
import { useLoggedTenant } from './model'
import { createProvider } from 'apprise-frontend-core/state/factory'
import { TenantPreferencesModule } from 'apprise-frontend-iam/tenant/modules'
import { useLogged } from 'apprise-frontend-iam/login/logged'

export type TenantProps = PropsWithChildren<Partial<ToggleConfig<TenantToggles> & TenantConfig & {

    formExcludes: FormExcludes<TenantExcludes>

}>>


// since (01/26): keep registries inlined so that it resets when this is remounted on HMR.
// if it didn't, then app initialisers would register multiple times with various forms of errors.

export const [TenantModuleProvider, useRegisteredTenantModules] = createProvider({
  
    modules: [] as TenantPreferencesModule[]
})


// initialises the model and loads users, and mounts the state if required.
export const Tenants = (props: TenantProps) => {

    const { children, toggles, formExcludes, focalPointFilter } = props

    return <TenantClientCache>
        <TenantCloneProvider>
            <TenantModuleProvider>
                <TenantConfigProvider focalPointFilter={focalPointFilter}>
                    <TenantToggleProvider toggles={toggles}>
                        <TenantExcludesProvider {...formExcludes}>
                            <TenantInitialiser>
                                <TenantLoader>
                                    <LanguageChangeObserver />
                                    {children}
                                </TenantLoader>
                            </TenantInitialiser>
                        </TenantExcludesProvider>
                    </TenantToggleProvider>
                </TenantConfigProvider>
            </TenantModuleProvider>
        </TenantCloneProvider>
    </TenantClientCache>

}

const LanguageChangeObserver = () => {

    const current = useLoggedTenant()

    const logged = useLogged()

    return logged.details.preferences.language ? null : <LanguageObserver language={current?.preferences.language} />
}